export default "__VITE_ASSET__CdOdj$TC__"